import { SessionResultModal } from './modules/sessionResultModal';

export const SessionStatisticWidget = (): React.JSX.Element => {
  return <SessionResultModal />;
};
